// extracted by mini-css-extract-plugin
export default {"goBack":"style_goBack__Usni9"};